import {Action, getModule, Module, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import ModuleApi from "@/store/api";
import {
    CabinetAssignedSpecialistDto,
    CabinetAssignedSpecialistRs,
    CareerHighlight,
    EducationHighlight
} from "@/types/assignedSpecialist";
import {mapToCabinetAssignedSpecialistDto} from "@/mappers/settings";

@Module({
    name: 'settings',
    dynamic: true,
    namespaced: true,
    store,
})
class ModuleSettings extends VuexModule {

    //Get information about specialist for settings
    @Action
    async getAssignedSpecialist() {
        const response = await ModuleApi.GET("/api/cabinet/auth/assigned-specialist") as CabinetAssignedSpecialistRs;
        return mapToCabinetAssignedSpecialistDto(response);
    }
}

export default getModule(ModuleSettings);
